import { Expose } from 'class-transformer';
import { Model } from './model';

export class MonthlyDashboardReports extends Model {
  @Expose() month: number;
  @Expose() year: number;
  @Expose() totalCount: number;
  @Expose() totalRetrieved: number;
}
